import React, { useState } from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import styles from "./ListingView.module.css";
import ValueDisplay from "../ValueDisplay/ValueDisplay";
import dayjs from "dayjs";
import TruncateText from "../TruncateText/TruncateText";

interface ListingViewProps {
	listing: any; // Replace `any` with the appropriate type for the listing object
}

const moneyFormat = new Intl.NumberFormat("en-US", {
	style: "currency",
	currency: "USD",
	maximumFractionDigits: 0, // rounds up
});

const shortDate = (value: string) => {
	return dayjs(value).format("MM/DD/YYYY");
};

const formatDate = (value: string | Date) => {
	return dayjs(value).format("MM/DD/YYYY");
};

const ListingView: React.FC<ListingViewProps> = ({ listing }) => {
	const [isExpanded, setIsExpanded] = useState(false);

	const toggleExpand = () => setIsExpanded(!isExpanded);

	return (
		<div className="grid grid-cols-12 gap-4 mt-1">
			<div className={`col-span-3 ${styles.carousel_container}`}>
				<div className={styles.image_loading}>{listing?.media?.filter((media: any) => media.mediaType === "IMAGE").length ? "Loading Images" : "No Images"}</div>
				<Carousel dynamicHeight={false} className={styles.carousel}>
					{listing?.media
						?.filter((media: any) => media.mediaType === "IMAGE")
						.map((media: any, i: number) => (
							<div key={i}>
								<img src={media.mediaURL} alt={`Listing Image ${i}`} />
							</div>
						))}
				</Carousel>
			</div>
			<div className="grid grid-cols-2 col-span-9 gap-4">
				<div>
					<div>
						Listing #:
						<a style={{ color: "#0084ff", marginLeft: "5px" }} target="_blank" href={`http://matrix.crmls.org/Matrix/Link?id=${listing.listingId}`} rel="noreferrer">
							{listing.listingId}
						</a>
					</div>
					<div>
						Address:{" "}
						{`${listing.streetNumberNumeric || ""} ${listing.streetName || ""} ${listing.streetSuffix || ""}, 
						${listing.city || ""}, ${listing.stateOrProvince || ""}, ${listing.postalCode || ""}`}
					</div>
					<div>
						<ValueDisplay title="List Price" value={moneyFormat.format(listing.listPrice)} />
						<ValueDisplay title="Status" value={listing.standardStatus} />
						<ValueDisplay title="List Contract Date" value={shortDate(listing.listingContractDate)} />
						<ValueDisplay title="Purchase Contract Date" value={formatDate(listing.purchaseContractDate)} />
					</div>
				</div>
				<div>
					<ValueDisplay title="Closed Date" value={listing.closeDate ? formatDate(listing.closeDate) : null} />
					<ValueDisplay title="Prop Type" value={listing.propertyType} />
					<ValueDisplay title="Prop Sub Type" value={listing.propertySubType} />
					<ValueDisplay title="Entry Date" value={formatDate(listing.onMarketTimestamp)} />
					<ValueDisplay title="On Market Date" value={formatDate(listing.onMarketDate)} />
					<ValueDisplay title="Days Active in MLS (DAM)" value={listing.daysOnMarket} />
				</div>
				<div className="col-span-2">
					<div>
						<b>Public Remarks</b>: <TruncateText text={listing?.publicRemarks} length={100} />
					</div>
				</div>
			</div>
		</div>
	);
};

export default ListingView;
